import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { canPlayWebm } from '../shared/canPlayWebm';

export function useCanPlayWebm(): boolean {
	const utilityContext = useUtilityContext();

	return canPlayWebm(utilityContext);
}
